import uiNotificationService from 'services/uiNotification.service';

import userService from 'resources/user/user.service';

import * as companyApi from 'resources/company/company.api';

export const deactivateTeamMember = async ({ id }) => {
  const updatedUser = await userService.updateUser({
    id,
    is_deactivated: true,
  });

  await companyApi.actualizeSubscriptionQty();

  uiNotificationService.showSuccess('Member deactivated successfully.');

  return updatedUser;
};
